module.exports = __webpack_public_path__ + "static/media/balance-l.d8810170.svg";